import React, { useState, useEffect, useRef } from "react";
import { frontendLiveDomain, liveStatus } from "../lib/lib.js";
import {
  FaInstagram,
  FaTwitter,
  FaFacebookF,
  FaYoutube,
  FaWhatsapp,
  FaPhoneAlt,
  FaClock,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";
import "./Footer.css";
import useSound from "use-sound";
import { MdMusicNote, MdMusicOff } from "react-icons/md";

const LANGUAGES = [
  { code: "en", name: "English" },
  { code: "hi", name: "Hindi" },
  { code: "bn", name: "Bengali" },
  { code: "gu", name: "Gujarati" },
  { code: "kn", name: "Kannada" },
  { code: "ml", name: "Malayalam" },
  { code: "mr", name: "Marathi" },
  { code: "or", name: "Odia" },
  { code: "pa", name: "Punjabi" },
  { code: "ta", name: "Tamil" },
  { code: "te", name: "Telugu" },
  { code: "ur", name: "Urdu" },
  { code: "as", name: "Assamese" },
  { code: "ne", name: "Nepali" },
  { code: "ks", name: "Kashmiri" },
  { code: "sa", name: "Sanskrit" },
  { code: "brx", name: "Bodo" },
  { code: "kok", name: "Konkani" },
  { code: "sat", name: "Santali" },
  { code: "mni", name: "Manipuri" },
  { code: "mai", name: "Maithili" },
  { code: "doi", name: "Dogri" },
  { code: "sd", name: "Sindhi" },
];

const MUSIC_PREFERENCE_KEY = "aanandam-music-enabled";

const Footer = () => {
  const IMAGE_BASE_URL =
    process.env.REACT_APP_IMAGE_BASE_URL || "https://aanandam.com/image";
  const [showOptions, setShowOptions] = useState(false);
  const [isPlaying, setIsPlaying] = useState(() => {
    try {
      return window.localStorage.getItem(MUSIC_PREFERENCE_KEY) !== "false";
    } catch {
      return true;
    }
  });
  const VIDEO_BASE_URL =
    process.env.REACT_APP_Video_BASE_URL || "https://aanandam.com/video";
  const [play, { stop }] = useSound(`${VIDEO_BASE_URL}/r.mp3`, {
    loop: true,
    volume: 0.5,
    html5: true,
    onplay: () => setIsPlaying(true),
    onstop: () => setIsPlaying(false),
    onloaderror: () => setIsPlaying(false),
    onplayerror: () => setIsPlaying(false),
  });

  const dropdownRef = useRef(null);

  useEffect(() => {
    window.googleTranslateElementInit = () => {
      if (window.google?.translate) {
        new window.google.translate.TranslateElement(
          {
            pageLanguage: "en",
            includedLanguages: LANGUAGES.map((l) => l.code).join(","),
            layout:
              window.google.translate.TranslateElement.InlineLayout.SIMPLE,
          },
          "google_translate_element",
        );
      }
    };

    if (!document.querySelector("#google-translate-script")) {
      const script = document.createElement("script");
      script.id = "google-translate-script";
      script.src =
        "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;
      document.body.appendChild(script);
    } else if (window.google && window.google.translate) {
      window.googleTranslateElementInit();
    }
  }, []);

  const handleLanguageChange = (langCode) => {
    document.cookie =
      "googtrans=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
    const cookie =
      `googtrans=/en/${langCode}; path=/` +
      (liveStatus ? `; domain=${frontendLiveDomain}` : "");
    document.cookie = cookie;
    window.location.reload();
  };

  useEffect(() => {
    try {
      if (window.localStorage.getItem(MUSIC_PREFERENCE_KEY) !== "false") {
        play();
      }
    } catch {
      play();
    }

    return () => stop();
  }, [play, stop]);

  const toggleMusic = () => {
    if (isPlaying) {
      stop();
      setIsPlaying(false);
      try {
        window.localStorage.setItem(MUSIC_PREFERENCE_KEY, "false");
      } catch {
        // Continue to support playback when storage is unavailable.
      }
    } else {
      play();
      setIsPlaying(true);
      try {
        window.localStorage.setItem(MUSIC_PREFERENCE_KEY, "true");
      } catch {
        // Continue to support playback when storage is unavailable.
      }
    }
  };

  return (
    <footer className="foot-menu">
      <div className="container py-5 allcenter">
        <img
          src={`${IMAGE_BASE_URL}/logooo.png`}
          className="img-fluid footer-logo2"
          alt="Logo"
        />

        <div className="footer-address">
          <FaMapMarkerAlt className="me-2 address-icon" />
          Kadamshree, Rana Ki Pyau, Near HDFC Bank,
          <br />
          Barsana, Mathura – 281405
        </div>

        <div className="contact-row">
          <div className="contact-item">
            <FaPhoneAlt className="contact-icon" />
            <div>
              <h5>Call Us</h5>
              <p>+91 7900304949</p>
            </div>
          </div>
          <div className="contact-item">
            <FaClock className="contact-icon" />
            <div>
              <h5>Opening Hours</h5>
              <p>10am – 7pm</p>
            </div>
          </div>
          <div className="contact-item">
            <FaEnvelope className="contact-icon" />
            <div>
              <h5>Email Us</h5>
              <p>sales@kadamshree.com</p>
            </div>
          </div>
        </div>

        <div className="social-icons mt-4">
          <a href="https://www.facebook.com/profile.php?id=61583679868661&rdid=6J7Nl1973gdhJzpM&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F18zfVtCu92%2F%3Fref%3D1#">
            <FaFacebookF />
          </a>
          <a href="https://www.instagram.com/aanandamvalleey?stkn=MWlrYmV5cHExd3R0YQ%3D%3D">
            <FaInstagram />
          </a>
          {/* <a href="#">
            <FaYoutube />
          </a> */}
          <a href="https://wa.me/917900304949" target="_blank">
            <FaWhatsapp />
          </a>
        </div>
      </div>

      {/* Hidden Google Translate */}
      <div
        id="google_translate_element"
        style={{ position: "absolute", left: "-9999px" }}
      ></div>

      {/* Floating Buttons */}
      <div className="floating-buttons" ref={dropdownRef}>
        {/* ✅ WhatsApp Floating Button */}
        <a
          href="https://wa.me/917900304949"
          target="_blank"
          rel="noopener noreferrer"
          className="circle-btn whatsapp"
          title="Chat on WhatsApp"
        >
          <FaWhatsapp />
        </a>

        {/* 🎵 Music Button */}
        <button
          onClick={toggleMusic}
          className={`circle-btn ${isPlaying ? "playing" : "stopped"}`}
          title={isPlaying ? "Stop Music" : "Play Music"}
        >
          {isPlaying ? <MdMusicNote /> : <MdMusicOff />}
        </button>

        {/* 🌐 Translate Button */}
        <button
          onClick={() => setShowOptions(!showOptions)}
          className="circle-btn globe"
          title="Translate"
        >
          🌐
        </button>

        {showOptions && (
          <div className="language-box">
            {LANGUAGES.map((lang) => (
              <button
                key={lang.code}
                onClick={() => handleLanguageChange(lang.code)}
                className="language-btn"
              >
                {lang.name}
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container d-block justify-content-between align-items-center flex-wrap">
          <div className="footer-links">
            <a href="image/FORM C KADAMSHREE DEVELOPERS.pdf" target="blank">
              Form-C Kadamshree
            </a>
            {/* <a href="image/Agreement for Sale.pdf" target="blank">Agreement for Sale</a> */}
            <a
              href="/images/APPLICATIONFORM.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Application Form
            </a>
            <a
              href="/images/RERAREGISTRATION.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Rera Registration
            </a>

            <a
              href="/images/mapaprroval.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Map Aprroval
            </a>

            {/* <a href="image/Allotment Letter.pdf" target="blank">
              Allotment Letter
            </a> */}
          </div>

          <div className="footer-links">
            <a
              href="https://www.up-rera.in/Projectsummary?UI0aPA1ISD=8AWgzCOMEmk%3d&hfFlag=v1P%2fc8ksBrs%3d&NPJ6RAme=gVRV4PPjcBk%3d&PaURJEMAN4=ZL9MNERkNdaKhRqXJ0X%2fD2U0wGn2KUxP&IRSAHEB=D6PY3lyims8%3d"
              target="_blank"
              rel="noopener noreferrer"
            >
              UP Rera
            </a>

            <a
              href="https://docs.google.com/document/d/16g9YGkQKfFjINqXh3xvuPeV9kOp27mn81n1UhBpxhPI/edit?tab=t.0"
              target="blank"
            >
              New Artical
            </a>
          </div>

          <small>© 2025 - Aanandam Valley</small>
        </div>

        {/* Designed by line */}
        <div className="designed-by">
          Designed and Developed By:{" "}
          <a href="https://hypertonic.co.in/" target="_blank" className="dop">
            <b>Hypertonic IT Solutions</b>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
